import * as React from 'react';

interface IBlogCard {
  url: string;
  image: {
    description: string;
    png: string;
    webp: string;
  };
  heading: string;
  blurb: string;
  tags: string[];
  articleDate: string;
  articleAuthor: string;
  mastheadSubhead: string;
}

const BlogCard: React.FC<IBlogCard> = ({
  url,
  image,
  heading,
  mastheadSubhead,
  tags,
  articleDate,
  articleAuthor,
}) => {
  return (
    <a href={url} className="blog-card bListing">
      <div className="picture">
        <picture>
          <source srcSet={image?.webp} type="image/webp" />
          <img
            src={image?.png}
            width="665"
            height="375"
            alt={image?.description}
          />
        </picture>
      </div>
      <div className="blog-card__content">
      {tags.length > 0 && (
            <ul className="blog-card__tags">
              {tags.map(tag => (
                <li key={tag} className="blog-card__tag">
                  {tag}
                </li>
              ))}
            </ul>
          )}
        <h3 className="blog-card__heading">{heading}</h3>
        <div className="blog-card__details">
          <div className="blog-card__info-tags">
          <p className="blog-card__info-tag"><a href={url} className="">{articleAuthor}</a></p>
          <p className="blog-card__info-tag">{articleDate}</p>              
          </div>
        </div>
        <p className="blog-card__description">{mastheadSubhead}</p>
      </div>
    </a>
  );
};

export default BlogCard;
